import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"automatic-numbering"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.998 9.99805H12.002V10.002H11.998V9.99805Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.998 20.998H12.002V21.002H11.998V20.998Z"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3 3H4C4.55228 3 5 3.4514 5 4.00368L5 10M5 10H3M5 10H7M17 3H18C18.5523 3 19 3.4514 19 4.00368V10M19 10H17M19 10H21M3 14H4C4.55228 14 5 14.4514 5 15.0037L5 21M5 21H3M5 21H7M17 14H20C20.5523 14 21 14.4477 21 15V16.5C21 17.0523 20.5523 17.5 20 17.5H18C17.4477 17.5 17 17.9477 17 18.5V21H21M11.998 9.99805H12.002V10.002H11.998V9.99805ZM11.998 20.998H12.002V21.002H11.998V20.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const AutomaticNumbering = Vue.extend<IconProps>({
  name: 'AutomaticNumberingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'automatic-numbering',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AutomaticNumbering;
